import { NgModule } from "@angular/core";
import { CommonModule } from "@angular/common";
import { TopicListComponent } from "@onsip/web/features/sayso/saysoSettings/topicList/topic-list.component";
import { MatListModule } from "@angular/material/list";
import { MaterialModule } from "@onsip/web/modules/material/material.module";
import { SpacerModule } from "@onsip/web/features/shared/components/spacer/spacer.module";

@NgModule({
  declarations: [TopicListComponent],
  exports: [TopicListComponent],
  imports: [CommonModule, MatListModule, SpacerModule, MaterialModule]
})
export class TopicListModule {}
